import { useMemo } from 'react'
import type { ContentVersionBlob } from '@opallabs/api/v3'
import * as styles from './styles'
import { getVersionDetails } from './versionDetails'

type VersionDetailsTableProps = {
  blob: ContentVersionBlob
}

/** Attributes of a version that the rendered preview doesn't show. */
export const VersionDetailsTable: React.VFC<VersionDetailsTableProps> = ({
  blob,
}) => {
  const details = useMemo(() => getVersionDetails(blob), [blob])
  if (details.length === 0) return null

  return (
    <>
      <h3 css={styles.sectionHeading}>Content Details</h3>
      <dl css={styles.detailsTable}>
        {details.map((detail, index) => (
          // Option display names can repeat across components; index keeps keys unique.
          <div css={styles.detailsRow} key={`${detail.label}-${index}`}>
            <dt css={styles.detailsLabel}>{detail.label}</dt>
            <dd css={styles.detailsValue}>{detail.value}</dd>
          </div>
        ))}
      </dl>
    </>
  )
}
